export default __webpack_public_path__ + "static/media/pointer.68ed3eb5.svg";